import technologyTypes from './technology-types.json'
import technologies from './technologies.json'

const api = {
  types: technologyTypes,
  items: technologies,
}

export default api

